import CIconButton from '@/shared/ui/CIconButton';
export default {
  name: 'PageControlButtons',
  components: {
    CIconButton: CIconButton
  },
  props: {
    isAgent: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};